import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faUserSecret,
    faPlus,
    faMinus,
    faVideo,
} from '@fortawesome/free-solid-svg-icons';

import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@mdi/font/css/materialdesignicons.min.css';

import VueSelect from 'vue-select';

import VueApexCharts from 'vue3-apexcharts';

import AOS from 'aos';
import 'aos/dist/aos.css';

import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

import './assets/styles/bootstrap.scss';

import 'vuetify/styles';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { createVuetify } from 'vuetify';
import { pt, en, es } from 'vuetify/locale';
import i18n, { bindVuetify } from './i18n';
import { getSavedLocale } from './i18n/locale';
import { applyColorScheme, bindColorScheme, readStoredDark } from './utils/colorScheme';

// Import the new Icon component
import Icon from './assets/icons/icons.vue';

const vuetify = createVuetify({
    components,
    directives,
    locale: {
        locale: getSavedLocale(),
        fallback: 'pt',
        messages: { pt, en, es },
    },
    theme: {
        defaultTheme: readStoredDark() ? 'dark' : 'light',
        themes: {
            light: {
                dark: false,
                colors: {
                    primary: '#1f1e61',
                    text: '#232323',
                    textSecondary: '#838383',
                    heading: '#080919',
                    background: '#EEF0FC',
                    cardBackground: '#FFFFFF',
                    fieldBackground: '#FFFFFF',
                    divider: '#D6D8DE',
                    turquoise: '#1ac7d0',
                    error: '#dc3545',
                },
            },
            dark: {
                dark: true,
                colors: {
                    primary: '#392497',
                    text: '#EAEAEA',
                    textSecondary: '#A6A6A6',
                    heading: '#F6F6F6',
                    background: '#13121A',
                    cardBackground: '#201E26',
                    fieldBackground: '#292730',
                    divider: '#2D2D2D',
                    turquoise: '#1ac7d0',
                    error: '#dc3545',
                },
            },
        },
    },
});

import Multiselect from 'vue-multiselect';
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

import VueTheMask from 'vue-the-mask';

import 'primeicons/primeicons.css';

import './assets/styles/global.scss';

import { VueReCaptcha } from 'vue-recaptcha-v3';


library.add(faUserSecret, faPlus, faMinus, faVideo, fas, fab);

import Vuex from 'vuex';
import store from './store';

const app = createApp(App);
app.config.devtools = false;

// ResizeObserver loop é benigno (Vuetify/modais/charts); evita overlay do webpack-dev-server.
if (typeof window !== 'undefined') {
    const isResizeObserverNoise = (message) =>
        typeof message === 'string' && message.includes('ResizeObserver loop');

    window.addEventListener('error', (event) => {
        if (isResizeObserverNoise(event?.message)) {
            event.stopImmediatePropagation();
            event.preventDefault?.();
        }
    });
}

app.use(store);
app.use(i18n);
app.use(VueTheMask);
bindVuetify(vuetify);
bindColorScheme(vuetify);
applyColorScheme(store.state.dark);

// app.use(VueReCaptcha, {
//   siteKey: '6LcWfigrAAAAAKY18LmZ7RsEcMoJIy2URspCgQy3', // sua chave
//   loaderOptions: {
//     autoHideBadge: true,
//   }
// });

app.config.warnHandler = (msg, vm, trace) => {
    // Filtrar avisos específicos do Vue
    if (msg.includes('Feature flag') || msg.includes('__VUE_PROD_HYDRATION_MISMATCH_DETAILS__')) {
        return;
    }
    // Filtrar avisos do Vue Router sobre rotas não encontradas
    if (msg.includes('No match found for location with path')) {
        return;
    }
    console.warn(msg, vm, trace);
};
app.component('VueApexCharts', VueApexCharts);
app.component('multiselect', Multiselect);
app.component('vue-select', VueSelect);
app.component('Icon', Icon);

app.use(router);
app.use(VuePlyr, { plyr: {} });
app.component('fa', FontAwesomeIcon);
app.component('QuillEditor', QuillEditor);
app.use(vuetify);
app.mount('#app');

AOS.init();

app.use(Vue3Toastify);
